import { useEffect, useRef, useState, lazy, Suspense } from "react";
import { Smile, Send } from "lucide-react";

const Picker = lazy(() => import("emoji-picker-react"));
const time = (iso) => { try { return new Date(iso).toLocaleTimeString([], { hour: "numeric", minute: "2-digit" }); } catch { return ""; } };

export const ChatPanel = ({ chat, me, onSend }) => {
  const [text, setText] = useState("");
  const [emoji, setEmoji] = useState(false);
  const list = useRef(null);
  const input = useRef(null);
  useEffect(() => { list.current?.scrollTo({ top: list.current.scrollHeight, behavior: "smooth" }); }, [chat.length]);
  const send = () => { if (!text.trim()) return; onSend(text.trim()); setText(""); setEmoji(false); };
  return (<>
    <div ref={list} className="flex-1 overflow-y-auto p-3 space-y-2" data-testid="meeting-chat-list">
      {chat.length === 0 && <p className="text-xs text-slate-500 text-center mt-6">No messages yet — say hi 👋</p>}
      {chat.map(c => { const mine = c.user_name === me; return (
        <div key={c.id} className={`flex flex-col ${mine ? "items-end" : "items-start"}`} data-testid="meeting-chat-msg">
          <span className="text-[10px] text-slate-500">{mine ? "You" : c.user_name} · {time(c.created_at)}</span>
          <span className={`text-sm px-3 py-1.5 rounded-2xl max-w-[85%] break-words ${mine ? "bg-blue-600 text-white rounded-br-sm" : "bg-slate-800 text-slate-100 rounded-bl-sm"}`}>{c.content}</span>
        </div>); })}
    </div>
    {emoji && <div className="border-t border-white/10" data-testid="meeting-emoji-picker"><Suspense fallback={<p className="p-3 text-xs text-slate-400">Loading emoji…</p>}>
      <Picker theme="dark" width="100%" height={320} lazyLoadEmojis searchPlaceHolder="Search emoji" onEmojiClick={(e) => { setText(t => t + e.emoji); input.current?.focus(); }} previewConfig={{ showPreview: false }} />
    </Suspense></div>}
    <div className="p-3 border-t border-white/10 flex gap-2">
      <button onClick={() => setEmoji(!emoji)} className={`px-2 rounded-lg ${emoji ? "bg-blue-600" : "bg-slate-800 hover:bg-slate-700"}`} title="Emoji" data-testid="meeting-emoji-btn"><Smile className="w-5 h-5" /></button>
      <input ref={input} value={text} onChange={e => setText(e.target.value)} onKeyDown={e => e.key === "Enter" && send()} placeholder="Message everyone" className="flex-1 min-w-0 bg-slate-800 rounded-lg px-3 py-2 text-sm outline-none" data-testid="meeting-chat-input" />
      <button onClick={send} className="bg-blue-600 px-3 rounded-lg" data-testid="meeting-chat-send"><Send className="w-4 h-4" /></button>
    </div>
  </>);
};
